<article
  class="rounded-lg border border-greyscale-200 bg-white p-5"
  [attr.data-testid]="'update-note-' + note().id"
>
  <header class="mb-3 flex flex-wrap items-center gap-3">
    <span
      class="rounded-full px-3 py-1 text-paragraph-xs-med"
      [class]="badgeClass()"
    >
      {{ "updateNotes.type." + note().type | transloco }}
    </span>
    <time
      class="text-paragraph-s-reg text-greyscale-500"
      [attr.datetime]="note().releasedAt"
    >
      {{ note().releasedAt | date: "longDate" }}
    </time>
  </header>

  <p class="whitespace-pre-line text-paragraph-s-reg text-greyscale-700">
    {{ content() }}
  </p>
</article>
